/**
 * How a shift's cost is WORDED. The receipt itself is React now
 * (ui/kit/DebriefSection.tsx); these two formatters stayed behind because
 * the shift state needs them outside any component.
 *
 * Read `src/learn/shift.ts` for why there is no par and no combined score.
 */

import { t } from '../i18n/i18n'

/**
 * Hours for display. Whole hours stay whole - a generic number formatter would
 * render an eight-hour ring change as "8.00", which claims a precision the
 * figure does not have. Fractions keep one decimal.
 */
export const hoursText = (h: number): string => (h % 1 === 0 ? String(h) : h.toFixed(1))

/**
 * Name the repair charge on the receipt.
 *
 * A wrong call is two repairs under one number - the one that was ordered and
 * the one that was actually needed - so naming the line after the aspect the
 * student picked would quietly understate it.
 */
export function repairLabel(called: string, actual: string | null, escalation = false): string {
  if (actual === null || actual === called) {
    // A correct call to escalate is time spent by facilities, not a repair
    // on this tool - and the receipt used to read "Repair — Nothing on this
    // tool", which is the one thing it was not.
    return escalation ? t('shift.CostEscalation', { label: called }) : t('shift.CostRepair', { label: called })
  }
  return t('shift.CostRepairBoth', { wrong: called, actual })
}
